import React, { useCallback, useContext, useRef } from 'react'
import { connect } from 'react-redux'

import { Logo, Menu } from './ui'
import { ReactComponent as CloseIcon } from 'i/icons/close_white.svg'

import talkProLogo from 'i/icons/talkpro-footer-logo.png'

import styles from './DashboardSidebar.module.scss'
import { useClickOutside, useWindowSize } from 'hooks'
import { MEDIA_BREAKPOINTS } from 'utils/constants'
import { UiContext } from 'context/ui'

const DashboardSidebar = (props) => {
  const { toggleSidebar } = props
  const { activePopupId } = useContext(UiContext)
  const windowSize = useWindowSize()
  const $container = useRef()

  const handleClose = useCallback(() => {
    if (windowSize.width < MEDIA_BREAKPOINTS.lg && activePopupId === null) {
      toggleSidebar()
    }
  }, [windowSize, activePopupId, toggleSidebar])

  useClickOutside($container, handleClose)

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarContainer} ref={$container}>
        {windowSize.width < MEDIA_BREAKPOINTS.lg && (
          <div className={styles.header}>
            <button className={styles.closeButton} type="button" onClick={toggleSidebar}>
              <CloseIcon className="icon size_mod" />
            </button>
          </div>
        )}
        {windowSize.width >= MEDIA_BREAKPOINTS.lg && <Logo />}
        <div className={styles.container}>
          <Menu
            setDashboardContent={props?.setDashboardContent}
            dashboardContentCurrentState={props?.dashboardContentCurrentState}
            clickToggle={handleClose}
            proCategory={props?.user?.category}
          />
          {/* <div className={styles.footer}>
            <div className={styles.qrBlock}>
              <QrMaker />
            </div>
          </div> */}
          <div className="bottom_footer">
            <div className="bottomFooter_title">
              <img src={talkProLogo} alt="" className="bottomFooter_logo" />
            </div>
            <div className="menu_bottom">
              <ul className="bottom_menuList">
                <li className="bottom_menuItem">
                  <a className="bottom_menuLink" href="https://join.talkpro.com/">
                    About
                  </a>
                </li>
                <li className="bottom_menuItem">
                  <a className="bottom_menuLink" href="https://join.talkpro.com/terms/">
                    Terms
                  </a>
                </li>
                <li className="bottom_menuItem">
                  <a className="bottom_menuLink" href="https://join.talkpro.com/privacy/">
                    Privacy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth: { user, error, attributes, isPro } }) => ({
  user,
  authError: error,
  attributes,
  isPro,
})

export default connect(mapStateToProps)(DashboardSidebar)
